/* Compatibility shim for the previous site's Reveal wrapper.
   The rebrand uses one orchestrated hero reveal only, so this
   simply renders its children with no scroll animation. */
export default function Reveal({ children, className = '' }) {
  return <div className={className}>{children}</div>;
}
